import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setNavigator } from "../utils/navigation";
import { useDispatch } from "react-redux";
import { LOGIN_SUCCESS } from "../store/Actions/Actions";
import { fetchAndBuildPermissions } from "../config/Permission_List";

const safeParseJSON = (s) => {
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
};

const useSetLoginData = () => {
  const dispatch = useDispatch();

  // ----------------------------------------------------
  // 2️⃣ Load User Permissions (Runs ONCE)
  // ----------------------------------------------------
  useEffect(() => {
    let cancelled = false;

    const token = localStorage.getItem("authToken");
    if (!token) return; // Skip permission load if logged out

    const userDetails = safeParseJSON(localStorage.getItem("userDetails"));
    const profile_data = userDetails?.profile_data || null;
    const actionCodes = userDetails?.actions || [];

    const cached = safeParseJSON(localStorage.getItem("builtPermissionsV1"));

    (async () => {
      // If cached permissions exist → load them immediately
      if (cached) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { profile_data, actions: cached },
        });
      }

      // Always get fresh permissions in the background
      try {
        const fresh = await fetchAndBuildPermissions(actionCodes);

        if (!cancelled) {
          localStorage.setItem("builtPermissionsV1", JSON.stringify(fresh));

          dispatch({
            type: LOGIN_SUCCESS,
            payload: { profile_data, actions: fresh },
          });
        }
      } catch {
        if (!cancelled) {
          dispatch({
            type: LOGIN_SUCCESS,
            payload: { profile_data, actions: cached || {} },
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);
};


const useInitialNavigation = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setNavigator(navigate); // Register global useNavigate()

    const token = localStorage.getItem("authToken");
    const path = location.pathname.toLowerCase();

    const PUBLIC_ROUTES = [
      "/login",
      "/forgot-password",
      "/auth-reset-password",
      "/reset-password",
      "/set-password",
    ];

    const isPublic = PUBLIC_ROUTES.includes(path);

    // User not logged in → Force to login (except public screens)
    if (!token && !isPublic) {
      navigate("/login", { replace: true });
      return;
    }

    // User logged in → prevent visiting /login page again
    if (token && path === "/login") {
      navigate("/projects", { replace: true });
      return;
    }
  }, [location.pathname, navigate]);
};

export { useInitialNavigation, useSetLoginData };
